<template>
    <div class="schedule-calendar-week">
        <span v-for="wk in weeks"
              class="schedule-calendar-week-item">{{wk}}</span>
    </div>
</template>
<script>
export default {
    props: {
        startWeek: Number
    },
    data() {
        return {
            cn: ['日', '一', '二', '三', '四', '五', '六'],
            en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
        }
    },
    computed: {
        weeks() {
            return this.startWeek === 0 ? this.cn : this.cn.concat(this.cn.splice(0, this.startWeek))
        }
    }
}
</script>
<style lang="scss">

    .schedule-calendar-week {
         display: flex;
         height: 60px;
         line-height: 60px;
         border: 1px solid #e8e8e8;
            // border-bottom: 0;
         >span{
            flex: 1;
            text-align: center;
            color: #333;
            border-right: 1px solid #e8e8e8;
            &:last-of-type{
                 border-right: 0;
            }
        }
    }
</style>
